import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "../../../types/RouteType";

const yardDashboardRoute: RouteType = {
    name: "Yard Dashboard",
    path: "/yard/dashboard",
    layout: "/app",
    viewportCard: {
        header: {
            component: () => import("./YardDashboard.Header"),
            title: "Yard Management Dashboard",
            enableRefreshButton: true,
        },
        body: {
            component: () => import("./YardDashboard.Body"),
            grayBackground: true,
        },
    },
    group: 'Yard',
  requiresAuth: true,
    requiresPermission: false,
    hidden: true,
    dialogs: [
        {
            name: "Add Location",
            component: () => import("../YardDialogs/AddLocation.Dialog"),
            title: "Add Yard Location",
            onSubmit: async ({ rootStore }) => {
                // Dialog submission logic is handled by the dialog component
                return true;
            },
            onSubmitValidation: ({ rootStore }) => {
                // Dialog validation is handled by the dialog component
                return true;
            },
            cancelButton: true,
            height: 600,
        },
    ],
    beforeEnter: async ({ rootStore }) => {
        try {
            // Load essential yard data
            const yardLocationsStore = rootStore.yardLocationsStore as ServiceStore;
            const yardInventoryItemsStore = rootStore.yardInventoryItemsStore as ServiceStore;
            const yardMapsStore = rootStore.yardMapsStore as ServiceStore;
            const trailerStore = rootStore.trailerStore as ServiceStore;

            await Promise.all([
                yardLocationsStore.find({ query: { $limit: 50 } }),
                yardInventoryItemsStore.find({ query: { $limit: 50 } }),
                yardMapsStore.find({ query: { $limit: 50 } }),
                trailerStore.find({ query: { $limit: 50 } }),
            ]);

            return true;
        } catch (error) {
            console.error("Failed to load yard dashboard data:", error);
            return false;
        }
    },
};

export default yardDashboardRoute;
